import { useContext, useEffect, useState } from "react";
import PopUp from "../PopUp";
import api from "../api/api";
import { AppContext } from "../../App";

export default function EditCategories() {
	const {
		editCategoriesPopupVisible,
		setEditCategoriesPopupVisible,
		setConfirm,
		setLoading,
		loadCategories,
		loadMenu,
	} = useContext(AppContext);
	const [category, setCategory] = useState(false);
	const [activePos, setActivePos] = useState(1);

	useEffect(() => {
		loadInitialData();
	}, []);

	const loadInitialData = async () => {
		if (editCategoriesPopupVisible === true) {
			setActivePos(1);
			return;
		}
		setLoading(true);
		try {
			const res = await api.postProtected("/categories/get/" + editCategoriesPopupVisible + "/");
			if (res.success == 1) {
				setCategory(res.data);
				setActivePos(Number(res.data?.active_pos) === 1 ? 1 : 0);
			} else
				setConfirm({
					title: "Errore",
					message: res.error,
				});
		} catch {
			setConfirm({
				title: "Errore",
				message: "Errore nel caricamento dei dati categoria",
			});
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		const data = Object.fromEntries(formData.entries());
		data.active_pos = activePos;
		data.active = activePos;

		setLoading(true);
		try {
			let res;
			if (category) {
				res = await api.postProtected("/categories/edit/" + category.id + "/", data);
			} else {
				res = await api.postProtected("/categories/add/", data);
			}

			if (res.success == 1) {
				setEditCategoriesPopupVisible(false);
				await loadCategories();
				if (typeof loadMenu === "function") await loadMenu();
			} else
				setConfirm({
					title: "Errore",
					message: res.error,
				});
		} catch {
			setConfirm({
				title: "Errore",
				message: "Errore nel salvataggio della categoria",
			});
		} finally {
			setLoading(false);
		}
	};
	const formKey = category ? "category-" + category.id : "category-new";

	return (
		<PopUp
			options={{
				title: category ? "Modifica Categoria" : "Nuova Categoria",
				subtitle: category ? "ID: " + category.id : "",
				onClose: () => setEditCategoriesPopupVisible(false),
			}}
		>
			<div className="inner-content">
				<div className="admin-edit-card">
					<form onSubmit={handleSubmit} className="admin-edit-form" key={formKey}>
						<div className="admin-edit-toggle-row">
							<div className="admin-edit-toggle-label">In Vendita</div>
							<button
								type="button"
								className={"table-switch" + (Number(activePos) === 1 ? " is-yes" : " is-no")}
								onClick={() => setActivePos((prev) => (Number(prev) === 1 ? 0 : 1))}
								aria-pressed={Number(activePos) === 1}
							>
								<div className="table-switch-track">
									<span className="table-switch-label yes">SI</span>
									<span className="table-switch-label no">NO</span>
									<span className="table-switch-knob"></span>
								</div>
							</button>
							<input type="hidden" name="active_pos" value={activePos} />
							<input type="hidden" name="active" value={activePos} />
						</div>
						<div className="admin-edit-field">
							<label>Nome Categoria</label>
							<input
								type="text"
								name="name"
								defaultValue={category ? category.name : ""}
								required
							/>
						</div>
						<div className="admin-edit-submit-row">
							<button type="submit" className="admin-edit-submit">
								Salva Categoria
							</button>
						</div>
					</form>
				</div>
			</div>
		</PopUp>
	);
}
